'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEVisualisationToolbar = undefined;

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _core = require('@blueprintjs/core');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({}, function (_ref) {
  var isRtl = _ref.isRtl;
  return {
    direction: isRtl ? 'rtl' : 'ltr'
  };
});

var StyledButtonGroup = (0, _glamorous2.default)(_core.ButtonGroup)({
  '&.pt-minimal .pt-button': {
    marginRight: '11px'
  },
  '&.pt-minimal > .pt-popover-target:last-child .pt-button, .pt-button-group.pt-minimal > .pt-button:last-child': {
    marginRight: '11px'
  }
}, function (_ref2) {
  var isRtl = _ref2.isRtl;
  return {
    '&.pt-minimal .pt-button::after': {
      right: isRtl ? '100%' : null,
      left: isRtl ? null : '100%'
    }

  };
});

var StyledMenu = (0, _glamorous2.default)(_core.Menu)({}, function (_ref3) {
  var isRtl = _ref3.isRtl;
  return {
    textAlign: isRtl ? 'right' : 'left',
    '& .pt-menu-item::before': {
      float: isRtl ? 'right' : 'left',
      marginLeft: isRtl ? '7px' : '0',
      marginRight: isRtl ? '0' : '7px'
    }
  };
});

var StyledButton = (0, _glamorous2.default)(_core.Button)({}, function (_ref4) {
  var isRtl = _ref4.isRtl;
  return {
    '& .pt-icon-standard': {
      marginRight: isRtl ? null : '7px',
      marginLeft: isRtl ? '7px' : null
    }
  };
});

var DEVisualisationToolbar = exports.DEVisualisationToolbar = function DEVisualisationToolbar(_ref5) {
  var isRtl = _ref5.isRtl,
      changeView = _ref5.changeView,
      labelRenderer = _ref5.labelRenderer,
      items = _ref5.items;
  return _react2.default.createElement(
    Wrapper,
    { isRtl: isRtl },
    _react2.default.createElement(
      StyledButtonGroup,
      { minimal: true, isRtl: isRtl },
      (0, _map2.default)(function (item) {
        if (item.children) {
          return _react2.default.createElement(
            _core.Popover,
            { position: _core.Position.BOTTOM },
            _react2.default.createElement(
              StyledButton,
              {
                key: item.labelId,
                isRtl: isRtl
              },
              _react2.default.createElement('span', { className: (0, _classnames2.default)('pt-icon-standard pt-icon-' + item.icon, { 'pt-align-right': isRtl }) }),
              labelRenderer({ id: item.labelId })
            ),
            _react2.default.createElement(
              StyledMenu,
              { isRtl: isRtl },
              (0, _map2.default)(function (_ref6) {
                var icon = _ref6.icon,
                    id = _ref6.id,
                    label = _ref6.label;
                return _react2.default.createElement(_core.MenuItem, {
                  iconName: icon,
                  text: label,
                  key: id,
                  id: id,
                  onClick: function onClick() {
                    return changeView(id);
                  },
                  className: (0, _classnames2.default)({ 'pt-active': id === id })
                });
              })(item.children)
            )
          );
        }
        return _react2.default.createElement(
          StyledButton,
          {
            onClick: function onClick() {
              return changeView(item.id);
            },
            isRtl: isRtl
          },
          _react2.default.createElement('span', { className: (0, _classnames2.default)('pt-icon-standard pt-icon-' + item.icon, { 'pt-align-right': isRtl }) }),
          labelRenderer({ id: item.labelId })
        );
      })(items)
    )
  );
};

DEVisualisationToolbar.proptypes = {
  labelRenderer: _propTypes2.default.func.isRequired,
  changeView: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool,
  items: _propTypes2.default.objectOf(_propTypes2.default.shape({
    icon: _propTypes2.default.string,
    id: _propTypes2.default.string,
    label: _propTypes2.default.string
  }))
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-visualisation-toolbar/index.js
// module id = 2028
// module chunks = 0